















import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import { EVENT_NAMES } from "@scrile/api-provider";
import InputFileMixin from "@/mixins/InputFileMixin";
import emitter from "@/lib/emitter";
import { getNameMimeType } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { EVENTS } from "@/const";

const inputFileMixin = InputFileMixin(config.fileTypes);

@Component({
  name: "BaseInputFile",
})
export default class BaseInputFile extends mixins(inputFileMixin) {
  @Prop({ type: Boolean, default: false })
  public readonly multiple!: boolean;

  @Prop({ default: null })
  public readonly files!: FileList | null;

  @Prop({ type: Number })
  public readonly minFiles!: number;

  public showFileUpload() {
    const input = this.$refs.input;
    if (input instanceof HTMLInputElement) {
      input.value = "";
      input.click();
    }
  }

  public selectFile(e: Event) {
    e.stopPropagation();
    const element = e.target as HTMLInputElement;
    const files = element.files
      ? Array.from(element.files).filter(f => {
          let type = getNameMimeType(f.name);
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          return !this.accept || (type && this.acceptTypes.includes(type));
        })
      : [];
    if (files.length > 0) {
      if (files.some(file => file.size > config.maxUploadFileBytesSize)) {
        emitter.emit(EVENT_NAMES.REQUEST_STATUS, {
          status: "error",
          message: $t("Your media exceeds the maximum amount of 2 gigabytes"),
        });
        return;
      }
      if (!!this.minFiles && files.length < this.minFiles) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, {
          text: $t("Please select at least {0} files", [this.minFiles]),
          position: "top",
        });
        return;
      }
      this.$emit("input", files);
      if (this.files === null) (this.$refs.input as HTMLInputElement).value = "";
    }
  }

  @Watch("files")
  public clearInput(newValue: FileList | null) {
    if (newValue === null) (this.$refs.input as HTMLInputElement).value = "";
  }
}
